/**
 * Links into the rest of the Vietmap ecosystem, in the home page footer
 * (signed-out landing). index.html repeats them in its static intro — keep
 * both in sync.
 */
export type EcosystemLink = { label: string; href: string };

export const ECOSYSTEM_LINKS: { title: string; links: EcosystemLink[] }[] = [
  {
    title: "Công cụ VIETMAP",
    links: [
      { label: "VIETMAP Tools", href: "https://tools.vietmap.vn/" },
      { label: "Live Map", href: "https://tools.vietmap.vn/tools/live-map" },
      { label: "Chuẩn hoá địa chỉ", href: "https://tools.vietmap.vn/tools/convert-address" },
      { label: "Tính chi phí API", href: "https://tools.vietmap.vn/tools/transaction-to-request" },
      { label: "API Playground", href: "https://tools.vietmap.vn/playground/" },
    ],
  },
  {
    title: "Tài liệu & tài khoản",
    links: [
      { label: "Tài liệu Maps API", href: "https://maps.vietmap.vn/docs/map-api/" },
      { label: "Web SDK", href: "https://maps.vietmap.vn/docs/sdk-web-gl/overview/" },
      { label: "Mobile SDK", href: "https://maps.vietmap.vn/docs/sdk-mobile/overview/" },
      { label: "Bảng giá", href: "https://maps.vietmap.vn/web#pricingSection" },
      { label: "Vietmap Console", href: "https://maps.vietmap.vn/console-v2/" },
    ],
  },
];
